<div
  class="cursor-pointer flex gap-3 rounded-2xl font-title px-5 py-4 border border-gray-200 w-full bg-white hover:bg-gray-50 active:scale-[0.98] transition shadow-md"
  role="button"
  tabindex="0"
>
    <!-- Nombre + Estado -->
    <div class="items-center text-sm text-gray-500">
      Sectores
    </div>

    <div class="flex flex-1 flex-wrap gap-2 items-center justify-end" #chipsContainer>
      @for(sector of sectorsToShow(); track sector.id){
        <lib-badge [color]="getSectorBadgeColor(sector.state)" [variant]="getSectorBadgeVariant(sector.state)" size="xs">
          {{sector.name}}
        </lib-badge>
      }
      @if(showEllipsis()){
        <lib-badge color="light" variant="light" size="xs">
          ...
        </lib-badge>
      }
    </div>


    <!-- Caudal -->
    <div class="flex flex-col justify-center">
      <lib-icon name="chevron-right"></lib-icon>
    </div>

</div>
